<template>
<a v-if="href"
   @click="$emit('click')"
   :class="`odr-text odr-text_link odr-text_link_color-${color} ${bold === 'true' ? 'odr-text_bold' : ''}`"
   :href="href"
   target="_blank">
    <slot></slot>
</a>
<text-regular v-else
              :color="color"
              @click="$emit('click')"
              link="true"
              :bold="String(bold)">
    <slot></slot>
</text-regular>
</template>
<script>
import { coloringMixin } from '../mixins/coloring'
import '../styles/text.scss'

export default {
    mixins: [coloringMixin],
    props: {
        href: {
            type: String,
            _descr: 'External link url',
        },
        bold: {
            type: String,
            _descr: 'Make text bold',
        },
    },
    components: {
        'text-regular': require('./text-regular.vue').default,
    },
}
</script>
